import React from 'react';
import { Play } from 'lucide-react';

const VideoSection = ({ video, onWatch }) => {
  return (
    <div className="flex items-center gap-3 my-6">
      <div className="relative w-[100px] h-[56px] rounded-lg overflow-hidden flex-shrink-0 bg-gradient-to-br from-purple-400 via-pink-300 to-purple-500">
        <img
          src={video.thumbnail}
          alt="Webinar thumbnail"
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-900">{video.channel}</p>
        <p className="text-xs text-gray-500 flex items-center gap-1">
          <Play className="w-2.5 h-2.5 fill-gray-500 text-gray-500" />
          {video.duration}
        </p>
      </div>
      <button
        onClick={onWatch}
        className="px-6 py-2.5 bg-indigo-500 hover:bg-indigo-600 text-white rounded-full text-sm font-medium transition-colors duration-200 flex-shrink-0"
      >
        Watch
      </button>
    </div>
  );
};

export default VideoSection;
